import React from 'react'
import './Checkout.css'
import Subtotal from './Subtotal'
import { useStateValue } from "./StateProvider";
import { getBasketTotal } from './reducer';
import CheckoutProduct from './CheckoutProduct';

function Checkout() {
    const [{ basket, user }, dispatch] = useStateValue();
    
    return (
        <div className='checkout'>
            <div className="checkout__left">
                <img className='checkout__ad'
                src='https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg'
                alt=''
                />
            <div>
                <h3>Hello, {user?.email}</h3>
                    <div className="checkout__title">
                        <h2>Your Shopping Basket</h2>

                        {basket.map(item => (
                            <CheckoutProduct
                                id={item.id} 
                                image={item.image} 
                                rating={item.rating}
                                title={item.title}
                                price={item.price}
                            />  
                               
                        ))}
                    </div>
            </div>
            </div>
            <div className="checkout__right">
                <Subtotal/>
            </div>
        </div>
    )
}

export default Checkout
